module.exports = {
	"description": "A list of monsters and other mythic creatures",
	"sources": "some from https://en.wikipedia.org/wiki/Mythic_humanoids, others from memory.",
	"names": [
		"angel",
		"brownie",
		"bugbear",
		"centaur",
		"chimera",
		"chupacabra",
		"cockatrice",
		"cyclops",
		"demon",
		"djinn",
		"dragon",
		"draugr",
		"dryad",
		"dwarf",
		"elemental",
		"elf",
		"fairy",
		"faun",
		"frost giant",
		"gargoyle",
		"genie",
		"ghast",
		"ghost",
		"ghoul",
		"giant",
		"gnome",
		"goblin",
		"golem",
		"gorgon",
		"gremlin",
		"griffon",
		"hag",
		"harpy",
		"hippogriff",
		"hobgoblin",
		"homonculus",
		"hydra",
		"imp",
		"incubus",
		"kappa",
		"kobold",
		"kraken",
		"lamassu",
		"leprechaun",
		"lich",
		"manticore",
		"mermaid",
		"merman",
		"minotaur",
		"mummy",
		"naga",
		"nix",
		"nymph",
		"ogre",
		"oni",
		"orc",
		"pegasus",
		"phoenix",
		"pixie",
		"poltergeist",
		"roc",
		"sasquatch",
		"satyr",
		"selkie",
		"siren",
		"spectre",
		"sphinx",
		"sprite",
		"succubus",
		"sylph",
		"thunderbird",
		"troll",
		"unicorn",
		"vampire",
		"valkyrie",
		"warg",
		"wendigo",
		"werewolf",
		"wight",
		"witch",
		"wraith",
		"wyvern",
		"yeti",
		"zombie"
	]
};


/** WEBPACK FOOTER **
 ** ./corpora/data/mythology/monsters.json
 **/